import React from 'react';

const SummaryCard = ({ title, value, detail, rate, color, icon }) => {
  const safeRate = rate === null || rate === undefined ? 0 : Math.max(0, Math.min(rate, 100));

  return (
    <article className="report-summary-card" style={{ '--card-color': color }}>
      <div className="report-summary-card__title">
        {icon}
        <span>{title}</span>
      </div>
      <div
        className={`report-summary-card__gauge ${rate === null ? 'is-empty' : ''}`}
        style={{ '--gauge-rate': `${safeRate * 3.6}deg` }}
      >
        <div>
          <strong>{value}</strong>
        </div>
      </div>
      <p>{detail}</p>
    </article>
  );
};

export default SummaryCard;

